import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import API from "config/ApiConfig";
import { Mosaic } from "react-loading-indicators";
// constants
// const API_BASE_URL = 'http://localhost:5000/api/admin';
const API_BASE_URL = API.API_ADMIN;
function getToken() {
  return localStorage.getItem('authToken');
}

// Fungsi untuk mendapatkan header dengan token JWT
function getAuthHeaders() {
  const token = getToken();
  if (!token) {
      throw new Error('No token available');
  }
  return {
      'Authorization': `Bearer ${token}`, // Format token JWT
      'Content-Type': 'application/json' // Jika perlu, untuk menentukan jenis konten
  };
}

export default function CardTable({ color }) {
  const [dataRekap, setDataRekap] = useState([]);
  const [tentors, setTentors] = useState({});
  const [siswa, setSiswa] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  const handleDropdownToggle = (_id) => {
    setOpenDropdownId(openDropdownId === _id ? null : _id);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        const response = await fetch(`${API_BASE_URL}/rekap/${id}`, {
          method: 'DELETE',
          headers: getAuthHeaders()
        });
        if (response.ok) {
          setDataRekap(dataRekap.filter(item => item._id !== id));
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        setError('Failed to delete record.');
        console.error('Error deleting record:', error);
      }
    }
  };


  //belum fixx untuk menghapus absen berdasarkan bulan
  const handleTruncatePresensi = async () => {
    if (window.confirm(`Yakin menghapus seluruh presensi untuk bulan ${month}?`)) {
      try {
        const response = await fetch(`${API_BASE_URL}/rekap/removeBulanan?month=${month}`, {
          method: 'DELETE',
          headers: getAuthHeaders() // Pastikan ini mengembalikan header yang benar
        });
        if (response.ok) {
          alert('Data presensi bulan berhasil dihapus');
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (err) {
        alert('Gagal menghapus data presensi.');
        console.error('Error menghapus presensi:', err);
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rekapResponse = await fetch(`${API_BASE_URL}/rekap`, {
          method: 'GET',
          headers: getAuthHeaders()
        });
        if (!rekapResponse.ok) {
          throw new Error(`HTTP error! Status: ${rekapResponse.status}`);
        }
        const rekapData = await rekapResponse.json();

        const tentorIds = [...new Set(rekapData.map(item => item.tentor_id))];
        const tentorRequests = tentorIds.map(id => 
          fetch(`${API_BASE_URL}/tentor/${id}`, {
            method: 'GET',
            headers: getAuthHeaders()
          }).then(response => response.json())
        );

        const siswaIds = [...new Set(rekapData.map(item => item.siswa_id))];
        const siswaRequests = siswaIds.map(id => 
          fetch(`${API_BASE_URL}/siswa/${id}`, {
            method: 'GET',
            headers: getAuthHeaders()
          }).then(response => response.json())
        );

        const [tentorData, siswaData] = await Promise.all([
          Promise.all(tentorRequests),
          Promise.all(siswaRequests)
        ]);

        const tentorsMap = tentorData.reduce((acc, tentor) => {
          if (tentor && tentor._id) {
            acc[tentor._id] = tentor;
          }
          return acc;
        }, {});
        const siswaMap = siswaData.reduce((acc, siswa) => {
          if (siswa && siswa._id) {
            acc[siswa._id] = siswa;
          }
          return acc;
        }, {});

        setDataRekap(rekapData);
        setTentors(tentorsMap);
        setSiswa(siswaMap);

      } catch (error) {
        setError(error.message);
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="flex m-4 justify-center items-center w-screen"><Mosaic color="#1177bc" size="large" text="Loading.." textColor="" /></div>
  }
  if (error) return <div>Error: {error}</div>;

  // Filter data based on the search query and date range
  const filteredData = dataRekap.filter(rekap => {
    const tentorName = tentors[rekap.tentor_id]?.nama.toLowerCase() || '';
    const siswaName = siswa[rekap.siswa_id]?.nama.toLowerCase() || '';
    const searchQueryLower = searchQuery.toLowerCase();

    const rekapDate = new Date(rekap.waktu_pembelajaran);
    const start = new Date(startDate);
    const end = new Date(endDate);

    const isInDateRange = (
      (!startDate || rekapDate >= start) &&
      (!endDate || rekapDate <= end)
    );

    return (
      isInDateRange &&
      (
        siswaName.includes(searchQueryLower) ||
        tentorName.includes(searchQueryLower) ||
        rekap.mata_pelajaran.toLowerCase().includes(searchQueryLower)
      )
    );
  });

  return (
    <>
      <div className="flex flex-wrap mt-4 mb-4">
        <a href="/admin/presensi/create">
          <button className="mr-4 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
            <i className="fas fa-plus"></i>
          </button>
        </a>
        {/* <div className="mr-4">
        <label>
          Bulan:
          <input
            type="number"
            min="1"
            max="12"
            value={month}
            onChange={(e) => setMonth(parseInt(e.target.value))}
            className="px-2 py-1 rounded-lg shadow"
          />
        </label>
      </div>
      <button
        className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        onClick={handleTruncatePresensi}
      >
        <i className="fas fa-trash mr-2"></i>
        Hapus Presensi Bulanan
      </button>*/}
        <input 
          type="text" 
          className="px-2 py-1 w-4 rounded-lg shadow space-x-2 mr-4" 
          placeholder="Cari..."
          value={searchQuery}
          onChange={handleSearchChange}
        /> 
        <div className="ml-4 mr-4 flex flex-direction-row">
          <input 
            type="date"
            className="px-2 py-1 rounded-lg shadow"
            value={startDate}
            onChange={handleStartDateChange}
          />
          <span className=" ml-2 mr-2 mt-2 font-red font-bold">to</span>
          <input 
            type="date"
            className="px-2 py-1 rounded-lg shadow"
            value={endDate}
            onChange={handleEndDateChange}
          />
        </div>
      </div>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                Presensi Table
              </h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                {["Nama Siswa", "Nama Tentor", "Mata Pelajaran", "Waktu Pembelajaran","Durasi", "Aksi"].map((heading, index) => (
                  <th
                    key={index}
                    className={
                      "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                      (color === "light"
                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                    }
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item) => (
                <tr key={item._id}>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    {siswa[item.siswa_id]?.nama || 'Tidak Diketahui'}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    {tentors[item.tentor_id]?.nama || 'Tidak Diketahui'}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    {item.mata_pelajaran}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    {new Date(item.waktu_pembelajaran).toLocaleDateString()}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                    {item.durasi}
                  </td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right">
                    <div className="relative inline-block text-left">
                      <div>
                        <button
                          type="button"
                          className="flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                          onClick={() => handleDropdownToggle(item._id)}
                        >
                          <i className="fas fa-ellipsis-v"></i>
                        </button>
                      </div>

                      {openDropdownId === item._id && (
                        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-10">
                           <a
                            href={`/admin/presensi/view/${item._id}`}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            <i className="fas fa-eye mr-2"></i> View
                          </a>
                          <a
                            href={`/admin/presensi/update/${item._id}`}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            <i className="fas fa-pen mr-2"></i> Update
                          </a>
                          <button
                            onClick={() => handleDelete(item._id)}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                          >
                            <i className="fas fa-trash mr-2"></i> Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

CardTable.defaultProps = {
  color: "light",
};

CardTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
